import { v4 as uuid } from 'uuid';

const HelpCenterRoutes = [
	{
		id: uuid(),
		menuitem: 'Help Center',
		link: '#',
		children: [
			{
				id: uuid(),
				menuitem: 'Help Center',
				link: '/marketing/help-center/'
			},
			{
				id: uuid(),
				menuitem: "FAQ's",
				link: '/marketing/help-center/faq/'
			},
			{
				id: uuid(),
				menuitem: 'Guides & Resources',
				link: '/marketing/help-center/guide/'
			},
			{
				id: uuid(),
				menuitem: 'Service Ticket',
				link: '/marketing/help-center/support/'
			},
			{
				id: uuid(),
				menuitem: 'Monitoring / Status',
				link: '/marketing/help-center/statuspage/'
			}
		]
	}
];

export default HelpCenterRoutes;
